// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"93a9ec1c","77":"6ae27b7a","162":"3e8c494a","341":"7590215c","438":"a1ec1a6d","453":"e96dd948","500":"dc64f228","579":"d100201d","636":"8d514fc7","664":"d6886857","684":"8935bdfc","787":"e13baff2","878":"e08c54c1","938":"f708b868"}[chunkId] + ".chunk.js";
};